import { useEffect } from 'react';
import useSession from '@/hooks/context/useSession';
import { isLogRocketEnabled } from '@/utils/logrocket.utils';
import Logger from '@/lib/logger';

/** Use support email or an internal member ID to find the affected user. */
export default function useLogRocketIdentify() {
  const {
    session: { member_id, session_id },
    userEmail,
    hasSupportAccess,
  } = useSession();

  useEffect(() => {
    const identity =
      hasSupportAccess && userEmail
        ? userEmail
        : member_id
          ? `member:${member_id}`
          : session_id
            ? `session:${session_id}`
            : null;

    if (identity && isLogRocketEnabled) {
      import('logrocket').then(({ default: LogRocket }) => {
        try {
          LogRocket.identify(identity);
        } catch {
          Logger.error("Wasn't able to identify user on LogRocket");
        }
      });
    }
  }, [member_id, session_id, userEmail, hasSupportAccess]);
}
